import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/admin/ABanner/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/admin/ABanner/addpost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/admin/ABanner/infoList",{
           id:params
    } )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA

};